import { render } from "./ListAppeals.vue?vue&type=template&id=4af60112"
import script from "./ListAppeals.vue?vue&type=script&lang=js"
export * from "./ListAppeals.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__